(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["NpawPlugin_p2p"] = factory();
	else
		root["NpawPlugin_p2p"] = factory();
})(self, () => {
return 